import styled from 'styled-components';
import {
  white, black, tekoMedium, red, blue, tekoLight, lighterBlue,
} from '../../../utils/theme';
import { mobile } from '../../../utils/breakpoints';

import { colorWithHover } from '../../../utils/animations';

export const Shadow = styled.div`
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  z-index: 21;
  overflow-y: scroll;
  width: 100%;
  overflow-x: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  position: relative;
  width: 90%;
  padding: 80px;
  max-width: 1200px;
  background-color: ${white};
  text-align: left;
  line-spacing: 1;
  letter-spacing: 1.3px;
  line-height: 18px;
  z-index: 5;
  max-height: calc(100% - 160px);
  overflow: auto;

  .footer-modal {
    padding: 0 15px 80px 0;
  }

  @media (max-width: ${mobile.max}px) {
    position: absolute;
    margin: 0;
    top: 0;
    left: 0;
    height: 100vh;
    max-height: none;
    width: 100vw;
    overflow-y: scroll;
    padding: 30px;
  }
`;

export const CloseCarousel = styled.a`
  position: absolute;
  right: 25px;
  top: 35px;
  color: #1c93e0;
  cursor: pointer;
  width: 28px;
`;

export const Contents = styled.div`
  color: ${black};
  margin: 56px 3px 0 17px;
  font-size: 12px;

  h1, h2, h3 {
    color: ${blue};
    ${tekoMedium}
    font-size: 36px;
    margin: 10px 0 -30px 0;
    text-align: left;
  }

  ul {
    list-style: initial;
    margin-left: 16px;
  }

  p {
    color: ${black};
    font-size: 12px;
    letter-spacing: 1.3px;
    line-height: 18px;
    margin: 50px auto 22px auto;
  }

  @media (max-width: ${mobile.max}px) {
    margin: 30px 0;
  }
`;

export const ButtonContainer = styled.div`
  text-align: center;
  margin-bottom: 80px;

  a {
    display: inline;
  }
`;

export const BlueButton = styled.a`
  ${colorWithHover({
    color: lighterBlue,
    inverse: white,
    borderWidth: '2px',
  })}
  ${tekoLight}
  font-size: 53px;
  text-transform: uppercase;
  padding: 6px 10px 3px 10px;
  letter-spacing: 6px;
  display: inline-block;
  padding-top: 12px;
  white-space: nowrap;

  ::before {
    content: '';
    height: 3px;
  }

  span {
    cursor: pointer;
    margin-right: -6px;
  }

  &.xfl-button--header {
    padding: 10px 15px;
  }

  .button-red {
    color: ${red};
  }

  @media (max-width: ${mobile.max}px) {
    font-size: 47px;
    padding-top: 8px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/footer-modal/styles/footer-modal.style.js